export default {
  'business': 'Negocios',
  'business.total': 'Total de negocios',
  'business.new': 'Nuevos negocios',
  'business.discharged': 'Negocios de baja',
  'business.evolution': 'Evolución de negocios',
  'business.quantity-sector': 'Cantidad de negocios por sector',
  'business.filter-sector': 'Filtrar por sector',
  'business.name-business': 'Nombre de negocio',
  'business.sector': 'Sector',
  'business.business': 'Negocio',
  'business.total-investment':'Inversión total',
  //sectorsData
  'business.placeholder-sector':'Seleccione un sector',
  'business.advocacy': 'Abogacía',
  'business.automotive': 'Automoción',
  'business.B2B': 'B2B',
  'business.customer-service': 'Servicio al consumidor',
  'business.appointments-personal': 'Citas y Personales',
  'business.electronic-commerce': 'Comercio electronico',
  'business.education': 'Educación',
  'business.employment-services': 'Servicios de empleo',
  'business.finance-insurance': 'Finanzas y Seguros',
  'business.health-medicine': 'Salud y Medicina',
  'business.household-items': 'Articulos de hogar',
  'business.servile-industries': 'Industrias serviles',
  'business.legal': 'Jurídico',
  'business.real-estate': 'Real estate',
  'business.technology': 'Tecnologia',
  'business.travel-hospitality': 'Viajes/Hosteleria',
};
